/**
 * Types of menu
 */
export enum EMenuTypes {
  LINK= 'link',
  TOGGLE= 'toggle',
  TOGGLELINK= 'toggle-link',
}
